import { t } from "@lingui/macro"
import { makeAutoObservable } from "mobx"
import React from "react"

import { CommunityAdminService, community_Author } from "src/api"
import { loads } from "src/channel/utils"
import { createLoadingKeys } from "src/lib/loading"
import { reportUnhandledApiError } from "src/lib/report"

interface ILike {
    authorName: string
}

export class CommunityLikesStore {
    static Context = React.createContext<CommunityLikesStore | null>(null)
    static LoadingKeys = createLoadingKeys("init")

    likes: ILike[] = []

    constructor() {
        makeAutoObservable(this)
    }

    @loads(() => CommunityLikesStore.LoadingKeys.init)
    async init(postId: number, commentId?: number) {
        try {
            const post = await CommunityAdminService.getV2AdminCommunityPost({
                postId,
            })

            const likes = Boolean(commentId)
                ? (post.comments ?? []).find((c) => c.comment_id === commentId)
                      ?.likes ?? []
                : post?.likes ?? []

            this.setLikes(likes.map(this.parseLike))
        } catch (e) {
            reportUnhandledApiError(e)
        }
    }

    private setLikes(likes: ILike[]) {
        this.likes = likes
    }

    private parseLike(like: community_Author): ILike {
        let authorName =
            like.author_name != null && like.author_name !== ""
                ? like.author_name
                : t`community-likes-modal.author-unknown-name`
        return { authorName }
    }
}
